import { Command } from 'commander';
import { GenerateWebhookCommand } from './generateWebhookCommand';
import { GenerateWebhookEventCommand } from './generateWebhookEventCommand';
import { GenerateWebhookReceiverCommand } from './generateWebhookReceiverCommand';

export function WebhookCommand(): Command {
  const cmd = new Command('webhook');
  cmd.alias('wh').description('Webhook related commands.');

  cmd.addCommand(GenerateWebhookCommand());
  cmd.addCommand(GenerateWebhookEventCommand());
  cmd.addCommand(GenerateWebhookReceiverCommand());
  return cmd;
}
